import { render, staticRenderFns } from "./widgetContent.vue?vue&type=template&id=e95e9d9e"
import script from "./widgetContent.vue?vue&type=script&lang=js"
export * from "./widgetContent.vue?vue&type=script&lang=js"
import style0 from "./widgetContent.vue?vue&type=style&index=0&id=e95e9d9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports